export const siteData = {
  brand: {
    name: "Dra. Giovana Gamborgi",
    tagline: "Odontologia que transforma",
    whatsappLink: "https://wa.me/554988871661?text=Ol%C3%A1!%20Vim%20pelo%20site%20e%20gostaria%20de%20agendar%20uma%20consulta.",
    instagramLink: "https://www.instagram.com/giovana_gamborgi/",
    invisalignLink: "https://providerbio-latam.invisalign.com/sv/1008901?fbclid=PAY2xjawJXxGZleHRuA2FlbQIxMAABpotBKFGEszrNgu_nqErlhcJEWeI4351WtHTTJvZRcQgstKaaXLov48JqcA_aem_K7vwD4M04G0dbtVvFM2XiQ#start",
    phone: "+55 49 98887-1661",
  },
  images: {
    doctorPhoto: "https://customer-assets.emergentagent.com/job_40339cf4-9cd7-480c-99c1-244b0552649b/artifacts/1n14dzbu_foto-giovana-gamborgi.jpeg",
    childPhoto: "https://customer-assets.emergentagent.com/job_40339cf4-9cd7-480c-99c1-244b0552649b/artifacts/vwffasb5_giovana-gamborgi-crian%C3%A7a.jpeg",
    explaining: "https://customer-assets.emergentagent.com/job_40339cf4-9cd7-480c-99c1-244b0552649b/artifacts/nkhdrcip_explicando.jpeg",
    qrCode: "https://customer-assets.emergentagent.com/job_40339cf4-9cd7-480c-99c1-244b0552649b/artifacts/23k2t79z_qrcode-guia-clareamento.png",
    consultorio: "https://customer-assets.emergentagent.com/job_sorriso-giovana/artifacts/fmu0gl3q_consultorio.jpeg",
  },
  hero: {
    headline: "Odontologia em Chapecó que transforma sorrisos com saúde e confiança",
    subheadline: "Dentista em Chapecó, atendimento cuidadoso, tecnologia avançada e foco no seu bem-estar",
    ctaText: "Agendar consulta pelo WhatsApp",
    socialProof: {
      rating: "5,0",
      reviews: 148,
      platform: "Google",
    },
  },
  reviews: [
    {
      id: 1,
      text: "Clínica acolhedora, desde a entrada e saída!",
      rating: 5,
    },
    {
      id: 2,
      text: "Profissional excepcional, prestativa e muito competente.",
      rating: 5,
    },
    {
      id: 3,
      text: "Atendimento infantil cuidadoso e atencioso. Minha filha amou e não teve medo nenhum!",
      rating: 5,
    },
    {
      id: 4,
      text: "Excelente profissional! Muito atenciosa e cuidadosa em cada detalhe.",
      rating: 5,
    },
  ],
  about: {
    name: "Giovana Portella Gamborgi",
    title: "Cirurgiã-dentista",
    location: "Chapecó – SC",
    credentials: ["Invisalign Top Doctor", "Sistema Ertty", "Ortodontia Digital", "Ortopedia Kids"],
    message: "Cuidado, tecnologia e atenção em cada detalhe do seu tratamento",
  },
  specialties: [
    {
      id: 1,
      category: "Ortodontia e Ortopedia dos Maxilares",
      items: [
        "Aparelho fixo metálico tradicional",
        "Aparelho estético em porcelana",
        "Aparelho autoligado",
        "Alinhadores transparentes",
        "Invisalign (alinhador invisível)",
        "Smiller (alinhador invisível nacional)",
      ],
    },
    {
      id: 2,
      category: "DTM",
      items: [
      "Placas interoclusais personalizadas para bruxismo e apertamento dental",
      "Auxílio no tratamento de estalos e travamentos mandibulares",
      "Viscossuplementação da ATM (articulação temporomandibular)",
      "Tratamento e aparelhos Intraorais para Ronco e Apneia do Sono",
      "Terapias conservadoras e controle da dor associadas à DTM (dores na face/cabeça, mandíbula e ATM)",
      ],
    },
    {
      id: 3,
      category: "Clínica Geral",
      items: ["Profilaxia ('limpeza' profissional) e prevenção da saúde bucal", "Restaurações dentárias estéticas", "Clareamento dental com acompanhamento profissional"],
    },
  ],
  invisalign: {
    title: "Invisalign",
    subtitle: "Alinhe seu sorriso de forma discreta e confortável",
    description: "O Invisalign utiliza alinhadores transparentes e removíveis, feitos sob medida para o seu sorriso. Sem fios, sem brackets — apenas tecnologia de ponta para resultados previsíveis e um sorriso que transforma.",
    benefits: [
      "Praticamente invisíveis",
      "Removíveis para comer e escovar",
      "Confortáveis e sem irritações",
      "Resultados previsíveis com planejamento digital 3D",
    ],
    ctaText: "Simule seu sorriso com Invisalign",
  },
  whitening: {
    title: "Clareamento Dental",
    subtitle: "Um sorriso mais branco e radiante com segurança",
    description: "O clareamento dental é um dos procedimentos estéticos mais procurados. Na nossa clínica, realizamos o tratamento com produtos de alta qualidade, de forma segura e personalizada para cada paciente.",
    qrCodeLabel: "Aponte a câmera e acesse o Guia de Cuidados com o Clareamento",
  },
  contact: {
    address: {
      building: "Edifício Lázio Executivo",
      suite: "Sala 807, 8º andar",
      street: "Avenida Porto Alegre - D, 427, Centro",
      city: "Chapecó – SC",
      zip: "89802-130",
    },
    hours: {
      weekdays: "Segunda a sexta: 08:30 – 18:00",
      weekends: "Sábado e domingo: Fechado",
    },
    mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3545.8!2d-52.6344!3d-27.0964!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94e4b5e5c5c5c5c5%3A0x0!2sAv.%20Porto%20Alegre%2C%20427%20-%20Centro%2C%20Chapec%C3%B3%20-%20SC%2C%2089802-130!5e0!3m2!1spt-BR!2sbr!4v1700000000000!5m2!1spt-BR!2sbr",
  },
};
